import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@abp/ng.core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule as CaCoreModule } from 'src/core/core.module';
import { CategorySelectorModule } from 'src/ui/category-selector/category-selector.module';
import { QueryEditorModule } from './query-editor.module';

import { QueryTreeNodeMergeComponent } from '../query/query-builder-nodes/query-tree-node-merge/query-tree-node-merge.component';

@NgModule({
  declarations: [QueryTreeNodeMergeComponent],
  imports: [
    CommonModule,
    CoreModule,
    CaCoreModule,
    ReactiveFormsModule,
    FormsModule,
    NgbDropdownModule,
    NgbTooltipModule,
    CategorySelectorModule,
    QueryEditorModule,
  ],
  exports: [QueryTreeNodeMergeComponent],
})
export class QueryMergeNodeModule {}
